<template>
  <div>
    <div class="row">
      <div class="col-12">
        <form id="form-subtopic" v-on:submit.prevent="saveSubtopic()">
          <div class="form-group">
            <ejs-dropdownlist v-model="dataForm.topic_id"
                              id='topicId'
                              name="topicId"
                              :placeholder="$t('topicsSubTopics.placeholder.select_topic')"
                              :fields='fields'
                              filterBarPlaceholder='e.g: aero' :ignoreAccent='ignoreAccent'
                              :allowFiltering='allowFiltering' :dataSource='topics'
                              data-msg-containerid="formTopicIdError">
            </ejs-dropdownlist>
            <div id="formTopicIdError"></div>
          </div>
          <div class="form-group">
            <ejs-textbox name="subtopic"
                         id="subtopic"
                         v-model="dataForm.subtopic"
                         :placeholder="$t('topicsSubTopics.placeholder.subtopic_name')"
                         data-msg-containerid="formSubtopicError">
            </ejs-textbox>
            <div id="formSubtopicError"></div>
          </div>

          <ejs-button
              v-if="!is_processing && data.type === 'create'"
              type='submit'
              cssClass="e-primary"
              :disabled="is_processing">
            {{ $t('topicsSubTopics.buttons.save') }}
          </ejs-button>

          <ejs-button
              v-if="!is_processing && data.type === 'update'"
              type='submit'
              cssClass="btn btn-warning"
              :disabled="is_processing">
            {{ $t('topicsSubTopics.buttons.update') }}
          </ejs-button>

          <ejs-button
              v-if="is_processing"
              type='submit'
              cssClass="e-primary"
              :disabled="is_processing">
            {{ $t('topicsSubTopics.messages.processing') }}
          </ejs-button>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'form-subtopic',
  props: {
    data: {
      required: true,
    }
  },
  mounted() {
    this.formObject = new FormValidator('#form-subtopic', this.optionsForms);
    this.topics = this.data.topics;
    if (this.data.type === 'update') {
      this.dataForm.subtopic = this.data.subtopic;
      this.dataForm.topic_id = this.data.topic_id;
      this.dataForm.subtopic_id = this.data.subtopic_id;
    }
  },
  data() {
    return {
      topics: [],
      allowFiltering: true,
      ignoreAccent: true,
      fields: {text: 'tema', value: 'id'},
      dataForm: {
        subtopic_id: undefined,
        subtopic: '',
        topic_id: undefined
      },
      formObject: '',
      optionsForms: {
        rules: {
          'topicId': {
            required: [true, this.$t('topicsSubTopics.validations.topicId')],
          },
          'subtopic': {
            required: [true,  this.$t('topicsSubTopics.validations.subtopic')],
          },
        }
      },
    }
  },
  watch: {
    is_processing(value) {
      if (!value) {
        Vue.prototype.$eventHub.$emit("closeSidebarClick");
      }
    }
  },
  computed: {
    is_processing() {
      return this.$store.getters['moduleTopicsSubtopics/isProcessing'];
    }
  },
  methods: {
    saveSubtopic() {

      let formStatus = this.formObject.validate();
      if(!formStatus){
        return;
      }

      let topic = this.topics.find(topic => topic.id === this.dataForm.topic_id);

      if (this.data.type === 'update') {
        this.$store.dispatch('moduleTopicsSubtopics/updateSubtopicInServer', {
          subtopic: this.dataForm.subtopic,
          topic: topic,
          subtopic_id: this.dataForm.subtopic_id,
        });
        return;
      }

      this.$store.dispatch('moduleTopicsSubtopics/saveSubtopicInServer', {
        subtopic: this.dataForm.subtopic,
        topic: topic,
      });
    }
  }
}
</script>